import { CardTitle } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import { Card, CardContent, CardHeader } from '@/components/ui/Card'
import { useAnalyticsStore } from '@/store/analytics.store'

export function AnalyticsMetrics() {
  const { t } = useTranslation()
  const reports = useAnalyticsStore(s => s.reports)

  const totalReports = reports.length
  const totalGrossPLN = reports.reduce((sum, report) => sum + (report.totalGrossPLN || 0), 0)
  const totalNetPLN = reports.reduce((sum, report) => sum + (report.totalNetPLN || 0), 0)

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium text-foreground/60">
            {t('analytics.total_reports', 'Total Reports')}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold">{totalReports}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium text-foreground/60">
            {t('analytics.total_gross_pln', 'Total Gross (PLN)')}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold">{totalGrossPLN.toFixed(2)}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium text-foreground/60">
            {t('analytics.total_net_pln', 'Total Net (PLN)')}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold">{totalNetPLN.toFixed(2)}</div>
        </CardContent>
      </Card>
    </div>
  )
}
